import { Alert, Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../store/hooks";
interface ImageGeneratorAlertProps {
  show: boolean;
  handleClose: () => void;
}
export const ImageGeneratorAlert = ({
  show,
  handleClose,
}: ImageGeneratorAlertProps) => {
  const isImageGeneratorEnabled= useAppSelector((s)=>s.ChatsState.isGenerateImage)
  return (
    isImageGeneratorEnabled && (
      <Box
        sx={{
          width: "100%",
          height: "62px",
          padding: 0,
          marginTop:{xs:"10px",sm:"0px"},
          "@media (max-width: 900px)": {
            height: "100px",
            display: "flex",
            alignItems: "flex-end",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height:{xs:"auto", sm: "62px"},
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "5px",
            flexDirection: "column",
            bgcolor: "var(--M-background102)",
            borderRadius: "10px",
            fontSize: {sx: "12px", md: "14px"},
            fontWeight: "400",
            color: "var(--Main_icons_color)",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "row",
              gap: "16px",
            }}
          >
            <AutoAwesomeOutlinedIcon sx={{ fontSize: "1.1rem" }} />
            <Typography variant="body1">
              Image generation is enabled!
            </Typography>
            <AutoAwesomeOutlinedIcon sx={{ fontSize: "1.1rem" }} />
          </Box>
            <Box
              sx={{
                fontWeight: "400",
                fontSize: {sx: "12px", md: "14px"},
                lineHeight: "25px",
                letterSpacing: "0.1px",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "3px",
              }}
            >
              For better experience, use Image Suite
              <Link
                to="/suites/image-suite"
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  lineHeight: "25px",
                  letterSpacing: "0.1px",
                  textDecoration: "underline",
                  textDecorationStyle: "solid",
                  textDecorationThickness: "0%",
                  color: "var(--A-background102)",
                }}
              >
                Open Image Apps
              </Link>
            </Box>
        </Box>
      </Box>
    )
  );
};
